module.exports = __webpack_public_path__ + "static/1-3b3fb1954fc25b4e261be03359e190c7.jpg";